import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.225 12.135a.182.182 0 01-.042-.203.182.182 0 01.042-.06l6.943-6.955a1.118 1.118 0 000-1.59 1.132 1.132 0 00-1.59 0l-6.943 6.947a.188.188 0 01-.27 0L5.422 3.326a1.132 1.132 0 00-1.836.364 1.119 1.119 0 00.246 1.227l6.943 6.955a.182.182 0 01.042.203.182.182 0 01-.042.06l-6.943 6.948a1.118 1.118 0 000 1.59 1.132 1.132 0 001.59 0l6.943-6.947a.188.188 0 01.27 0l6.943 6.948a1.132 1.132 0 001.836-.364 1.118 1.118 0 00-.246-1.227l-6.943-6.948z",
      fill: "#2D6DED"
    }
  )
);
export {
  e as default
};
